import React, { Component } from 'react';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';

class CustomDropdownMenu extends Component {
    constructor(props) {
        super(props);
        this.handleRootClose = this.handleRootClose.bind(this);
    }

    handleRootClose(event) {
        this.props.onClose(event, { source: 'rootClose' });
    }

    render() {
        const { open, rootCloseEvent } = this.props;
        return (
            <RootCloseWrapper
                disabled={!open}
                onRootClose={this.handleRootClose}
                event={rootCloseEvent}
            >
                <ul className={`dropdown-menu ${this.props.className || ''}`}
                    style={this.props.style}
                    role='menu'
                >
                    {this.props.children}
                </ul>
            </RootCloseWrapper>
        );
    }
}

export default CustomDropdownMenu;